<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="title">Title</label>
        <input
          type="text"
          class="form-control"
          v-model="title"
          placeholder="Enter title"
          :class="$v.title.$error ? 'is-invalid' : ''"
          id="title"
          name="title"
        />
        <div class="invalid-feedback" role="alert" v-if="$v.title.$error">
          <strong>Title is required</strong>
        </div>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          name="description"
          id="description"
          v-model="description"
          class="form-control"
          rows="5"
          placeholder="Enter description"
          :class="$v.description.$error ? 'is-invalid' : ''"
        ></textarea>
        <div class="invalid-feedback" role="alert" v-if="$v.description.$error">
          <strong>Description is required</strong>
        </div>
      </div>
      <div class="form-group">
        <label for="keywords">Keywords</label>
        <textarea
          name="keywords"
          id="keywords"
          v-model="keywords"
          class="form-control"
          rows="3"
          placeholder="Enter keywords"
          :class="$v.keywords.$error ? 'is-invalid' : ''"
        ></textarea>
        <div class="invalid-feedback" role="alert" v-if="$v.keywords.$error">
          <strong>Keywords are required</strong>
        </div>
      </div>
      <div class="form-group">
        <label for="slug">Slug</label>
        <input
          type="text"
          class="form-control"
          :value="slug"
          placeholder="Slug"
          name="slug"
          id="slug"
          disabled
        />
      </div>
      <div class="form-group">
        <label for="content">Content</label>
        <div :style="$v.content.$error ? 'border: 1px solid red' : ''">
          <quill-editor v-model="content"></quill-editor>
        </div>
        <div class="invalid-feedback" role="alert" v-if="$v.content.$error">
          <strong>Content is required</strong>
        </div>
      </div>
      <div class="form-group">
        <label for="cover_photo">Cover Photo</label>
        <input
          type="file"
          accept="image/*"
          name="cover_photo"
          id="cover_photo"
          class="form-control"
          @change="handleCoverUpload"
          :class="$v.$error && cover_photo_valid == false ? 'is-invalid' : ''"
        />
        <div v-if="cover_photo_upload">
          <img
            :src="cover_photo_url"
            class="img-fluid img-responsive w-50 mt-2"
            alt="Cover Photo"
          />
        </div>
        <small
          class="d-block text-danger mt-2"
          role="alert"
          v-if="$v.$error && cover_photo_valid == false"
        >
          <strong>Cover photo is required</strong>
        </small>
      </div>
      <div class="form-group">
        <label for="thumbnail">Thumbnail</label>
        <input
          type="file"
          accept="image/*"
          name="thumbnail"
          id="thumbnail"
          class="form-control"
          @change="handleThumbUpload"
          :class="$v.$error && thumbnail_valid == false ? 'is-invalid' : ''"
        />
        <div v-if="thumbnail_upload">
          <img
            :src="thumbnail_url"
            class="img-fluid img-responsive w-50 mt-2"
            alt="Thumbnail"
          />
        </div>
        <small
          class="d-block text-danger mt-2"
          role="alert"
          v-if="$v.$error && thumbnail_valid == false"
        >
          <strong>Thumbnail is required</strong>
        </small>
      </div>
      <div class="form-group">
        <button class="btn btn-primary" @click="updatePost">Update Post</button>
        <button class="btn btn-secondary" @click="backToAllPosts">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const noContentCheck = (value) => value != "<p>No content available</p>";
// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
 
import { quillEditor } from 'vue-quill-editor';
export default {
  name: "EditPost",
  props: {
    post_title: {
        default: ""
    },
    post_description: {
        default: ""
    },
    post_keywords: {
        default: ""
    },
    post_slug: {
        default: ""
    },
    post_content: {
        default: "<p>No content available</p>"
    },
    post_cover_photo: {
        default: ""
    },
    post_cover_photo_upload: {
        default: false
    },
    post_cover_photo_url: {
        default: ""
    },
    post_thumbnail: {
        default: ""
    },
    post_thumbnail_upload: {
        default: false
    },
    post_thumbnail_url: {
        default: ""
    },
    post_uid: {
        default: ""
    }
  },
  components: {
      'quill-editor': quillEditor
  },
  data() {
    return {
      title: "",
      description: "",
      keywords: "",
      slug: "",
      content: "<p>No content available</p>",
      cover_photo: "",
      cover_photo_upload: false,
      cover_photo_url: "",
      thumbnail: "",
      thumbnail_upload: false,
      thumbnail_url: "",
      post_id: ""
    };
  },
  beforeMount() {
      this.title = this.post_title;
      this.description = this.post_description;
      this.keywords = this.post_keywords;
      this.slug = this.post_slug;
      this.cover_photo_url = this.post_cover_photo_url;
      if(this.cover_photo_url) {
          this.cover_photo_upload = true;
      }
      this.thumbnail_url = this.post_thumbnail_url;
      if(this.thumbnail_url) {
          this.thumbnail_upload = true;
      }
      this.content = this.post_content;
      this.post_id = this.post_uid;
  },
  validations: {
    title: {
      required,
    },
    description: {
      required,
    },
    keywords: {
      required,
    },
    content: {
      required,
      noContentCheck,
    },
  },
  methods: {
    backToAllPosts() {
      window.location.href = "/posts-management";
    },
    updatePost() {
      this.$v.$touch();
      if (
        this.$v.$invalid
      ) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const formData = new FormData();
        const headers = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("keywords", this.keywords);
        formData.append("slug", this.slug);
        formData.append("content", this.content);
        if(this.cover_photo_valid) {
            formData.append("cover_photo", this.cover_photo);
        }
        if(this.thumbnail_valid) {
            formData.append("thumbnail", this.thumbnail);
        }

        axios
          .post("/posts-management/" + this.post_id + "/update", formData, headers)
          .then((response) => {
            this.backToAllPosts();
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    handleThumbUpload(event) {
      this.thumbnail = "";
      this.thumbnail_url = "";
      this.thumbnail_upload = false;
      let files = event.target.files;
      this.thumbnail = files[0];
      this.thumbnail_url = URL.createObjectURL(this.thumbnail);
      this.thumbnail_upload = true;
    },
    handleCoverUpload(event) {
      this.cover_photo = "";
      this.cover_photo_url = "";
      this.cover_photo_upload = false;
      let files = event.target.files;
      this.cover_photo = files[0];
      this.cover_photo_url = URL.createObjectURL(this.cover_photo);
      this.cover_photo_upload = true;
    },
  },
  computed: {
    thumbnail_valid() {
      if (this.thumbnail) {
        return true;
      } else {
        return false;
      }
    },
    cover_photo_valid() {
      if (this.cover_photo) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
